import Button from 'components/Button/Button';
import PlainButton from 'components/Button/PlainButton/PlainButton';
import FieldInput from 'components/FieldInput/FieldInput';
import React, { Fragment, useState, useEffect } from 'react';
import { createRef } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { sendFeedbackForm, setErrorMessageFeedbackForm, setLoadingFeedbackForm, setSuccessFeedbackForm } from 'store/actions';

import './FeedbackFormModal.scss';

const FeedbackFormModal = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { successFeedbackForm, loadingFeedbackForm, errorMessageFeedbackForm } = useSelector((state) => state.feedbackForm)
    const titleRef = createRef();
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [isFormInvalid, setIsFormInvalid] = useState(false);

    useEffect(() => {
        if (titleRef.current) titleRef.current.focus();

        // reset redux state
        dispatch(setSuccessFeedbackForm(false));
        dispatch(setLoadingFeedbackForm(false));
        dispatch(setErrorMessageFeedbackForm(null));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const resetState = () => {
        setTitle('');
        setContent('');
        setIsFormInvalid(false);
        dispatch(setSuccessFeedbackForm(false));
    };
    const currentUrl = window.location.href;

    const submitFeedback = () => {
        if (title.trim() === '' || content.trim() === '') {
            setIsFormInvalid(true);
            dispatch(setErrorMessageFeedbackForm(t('feedbackForm.emptyFormError')))
            return;
        }
        setIsFormInvalid(false);
        dispatch(sendFeedbackForm({
            current_url: currentUrl,
            subject: title,
            description: content,
        }))
    };

    return (
        <Modal
            show
            aria-labelledby="example-modal-sizes-title-lg"
            className="feedback-form-modal"
        >
            <Modal.Body className="feedback-form-modal-body">
                {
                    !successFeedbackForm ? (
                        <>
                            <div className="feedback-form-modal-title">
                                {t('feedbackForm.modalTitle')}
                            </div>
                            <input
                                ref={titleRef}
                                id="feedback-form-modal-input-title"
                                placeholder={t('feedbackForm.modalInputTitlePlaceholder')}
                                className={isFormInvalid && title.trim() === '' ? 'error' : ''}
                                value={title}
                                onChange={(event) => {
                                    setTitle(event.target.value);
                                }}
                            />
                            <textarea
                                id="feedback-form-modal-input-content"
                                placeholder={t('feedbackForm.modalInputContentPlaceholder')}
                                className={isFormInvalid && content.trim() === '' ? 'error' : ''}
                                value={content}
                                onChange={(event) => setContent(event.target.value)}
                            />
                            {
                                errorMessageFeedbackForm && (
                                    <div className="feedback-form-modal-error">
                                        {errorMessageFeedbackForm}
                                    </div>
                                )
                            }
                            <div className="form-actions">
                                <PlainButton className="button-cancel" size="medium" onClick={() => props.closeModal()}>{t('feedbackForm.modalCancel')}</PlainButton>
                                <Button
                                    className="button-submit"
                                    size="medium"
                                    disabled={loadingFeedbackForm}
                                    onClick={() => submitFeedback()}>
                                    { loadingFeedbackForm ? (
                                        <i className="ic-spinner" style={{ width: 16 }}></i>
                                    ) : t('feedbackForm.modalSendFeedback')
                                    }
                                </Button>
                            </div>
                        </>
                    ) : (
                        <div className="feedback-form-modal-success">
                            <i className="ic-archive-box" style={{ width: 60, height: 60 }} />
                            <div className="feedback-form-modal-success-title">
                                {t('feedbackForm.modalSuccessTitle')}
                            </div>
                            <div className="feedback-form-modal-success-message">
                                {t('feedbackForm.modalSuccessMessage')}
                            </div>
                            <PlainButton className="button-send-another-feedback" size="medium" onClick={() => resetState()}>{t('feedbackForm.modalSendAnotherFeedback')}</PlainButton>
                            <PlainButton className="button-close" size="medium" onClick={() => props.closeModal()}>{t('feedbackForm.modalClose')}</PlainButton>
                        </div>
                    )
                }
            </Modal.Body>
        </Modal>
    );
};

export default FeedbackFormModal;
